// locale-unextracted-ignore-file
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';

import { CustomScreenDateRangeTab } from './CustomScreenDateRangeTab';
import { CustomScreenDownloadMediaTab } from './CustomScreenDownloadMediaTab';

/**
 * Demo page with tabs for date range selector and download media notification views.
 */
export function CustomPage() {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box p={4}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1">
          Custom Screen
        </Typography>
      </Box>
      <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} sx={{ mb: 2 }}>
        <Tab label="Date range" />
        <Tab label="Download media notification views" />
      </Tabs>
      {tabIndex === 0 && <CustomScreenDateRangeTab />}
      {tabIndex === 1 && <CustomScreenDownloadMediaTab />}
    </Box>
  );
}
